/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Add_TableInputs */



/**
* | output |
* | --- |
* | "Table" |
*
* @param {Rounds_Add_TableInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_add_table = /** @type {((inputs?: Rounds_Add_TableInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Add_TableInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Table")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mesa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mesa")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tavolo")
	return /** @type {LocalizedString} */ ("Table")
});